module.exports = __webpack_public_path__ + "src/assets/img/page9/aa548030a3fb7188238d6081b2aae069.png";